import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Investments from './pages/Investments';
import InvestmentDetails from './pages/InvestmentDetails';
import Transactions from './pages/Transactions';
import OfferingPerformanceSimple from './pages/OfferingPerformanceSimple';
import AdditionalMetrics from './pages/AdditionalMetrics';
import Layout from './components/Layout';
import PortfolioLayout from './components/PortfolioLayout';
import ForgotPassword from './pages/ForgotPassword';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminAuditLogs from './pages/AdminAuditLogs';
import AdminViewAsUser from './pages/AdminViewAsUser';
import AdminInvestorsOverview from './pages/AdminInvestorsOverview';
import ProfileSettings from './pages/ProfileSettings';

// Create React Query client with optimized settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // Data fresh for 5 minutes
      cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus
      retry: 1, // Retry failed requests once
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Protected Portfolio Routes */}
        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
        <Route path="/dashboard/transactions" element={<Layout><Transactions /></Layout>} />
        <Route path="/dashboard/settings" element={<Layout><ProfileSettings /></Layout>} />
        
        {/* Portfolio Routes with Tabs */}
        <Route path="/dashboard/portfolio" element={<Layout><PortfolioLayout /></Layout>}>
          <Route index element={<Navigate to="/dashboard/portfolio/performance" replace />} />
          <Route path="investments" element={<Investments />} />
          <Route path="performance" element={<OfferingPerformanceSimple />} />
          <Route path="additional-metrics" element={<AdditionalMetrics />} />
        </Route>
        <Route path="/dashboard/portfolio/investment/:id" element={<Layout><InvestmentDetails /></Layout>} />

        {/* Admin Routes */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/investors-overview" element={<AdminInvestorsOverview />} />
        <Route path="/admin/audit-logs" element={<AdminAuditLogs />} />
        <Route path="/admin/view-as-user/:userId" element={<AdminViewAsUser />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
    </QueryClientProvider>
  );
}

export default App;
